import ConfirmDialog from './ConfirmDialog.vue';

// Registra this.$confirm(message, options) -> Promise<boolean>.
// Reemplazo async del confirm() nativo, con el theming de la app. Es SOLO para
// confirmaciones (dos botones); los avisos de exito/error se manejan con los
// componentes de alerts existentes, no con este dialogo.
//
//   const ok = await this.$confirm('¿Borrar este producto?', { variant: 'danger' });
//   if (!ok) return;
//
// options: { title, okText, cancelText, variant }
// variant: 'primary' (default) | 'danger' — 'danger' agrega icono de alerta y
// pinta rojo el boton Aceptar (para acciones destructivas).
let instance = null;

export default {
  install(Vue) {
    function getInstance() {
      if (!instance) {
        const Ctor = Vue.extend(ConfirmDialog);
        instance = new Ctor();
        // Se monta una sola vez, colgado de <body>, fuera del arbol de la app.
        instance.$mount();
        document.body.appendChild(instance.$el);
      }
      return instance;
    }

    Vue.prototype.$confirm = function (message, options) {
      return getInstance().open(message, options);
    };
  },
};
